import React from 'react';
import Chart from 'react-apexcharts';

const ResourceDemandModelChart = ({ data, type }) => {
    // Transform the data into the format 
    const hourEndValues = data.map(item => item.hour_end);

    let series = [];
    let titleText = '';

    switch (type) {
        case 'CheckOutCheckIn':
            series = [
                {
                    name: 'Checkouts',
                    data: data?.map(item => item?.checkouts)
                },
                {
                    name: 'Cleaned Rooms',
                    data: data?.map(item => item?.cleaned_rooms)
                },
                {
                    name: 'Checkins',
                    data: data?.map(item => item?.checkins)
                }
            ];
            titleText = 'Getting Dirty Rooms Clean Before Check-ins';
            break;
        case 'DirtyClean':
            series = [
                {
                    name: 'Vacant Dirty Rooms',
                    data: data?.map(item => item?.vacant_dirty_rooms)
                },
                {
                    name: 'Cleaned Rooms',
                    data: data?.map(item => item?.cleaned_rooms)
                }
            ];
            titleText = 'Rooms Vacant Dirty Versus Rooms Ready to Occupy';
            break;
        case 'Resources':
            series = [
                {
                    name: 'Cleaned Rooms',
                    data: data?.map(item => item?.cleaned_rooms)
                },
                {
                    name: 'Scheduled Resources',
                    data: data?.map(item => item?.scheduled_resources)
                },
                {
                    name: 'Cleaning Capacity Rooms',
                    data: data?.map(item => item?.cleaning_capacity_rooms)
                }
            ];
            titleText = 'Rooms Vacant Dirty Versus Scheduled Capacity';
            break;
        case 'CheckInOut':
            series = [
                {
                    name: 'Cumulitive Checkout',
                    data: data?.map(item => item?.cumulative_checkouts)
                },
                {
                    name: 'Clean Rooms',
                    data: data?.map(item => item?.clean_rooms)
                },
                {
                    name: 'Cumulitive Checkins',
                    data: data?.map(item => item?.cumulative_checkins)
                }
            ];
            // titleText = 'Cumulative Checkouts, Clean Rooms, and Checkins Overview';
            break;
        default:
            series = [];
            titleText = '';
    }

    // Find the maximum value from the series data
    const allData = series.flatMap(serie => serie.data);
    const maxYValue = Math.max(...allData) + 5;

    const options = {
        chart: {
            type: 'line',
            height: 450,
            zoom: {
                enabled: false // Disable zoom to disable user interaction
            },
            toolbar: {
                show: false // Hide toolbar to disable user interaction
            }
        },
        title: {
            text: titleText,
            align: 'center',
            style: {
                fontSize: '20px',
                color: '#333'
            }
        },
        xaxis: {
            categories: hourEndValues,
            title: {
                text: 'Hour End',
                style: {
                    color: '#333'
                }
            },
            tickAmount: 23, // To show each hour from 1 to 24
            labels: {
                style: {
                    colors: '#333', // Set x-axis labels color to a lighter shade
                    fontSize: '10px' // Smaller font size for x-axis labels
                }
            }
        },
        yaxis: {
            title: {
                text: 'Unit Count',
                style: {
                    color: '#333'
                }
            },
            labels: {
                style: {
                    colors: '#333' // Set y-axis labels color to a lighter shade
                }
            },
            min: 0,
            max: maxYValue // Set the max value of y-axis
        },
        stroke: {
            curve: 'smooth',
            width: 2, // Thinner lines for the series
            colors: ['#1f77b4', '#2ca02c', '#ff7f0e', '#d62728', '#9467bd'], // Darker colors for the series
            dashArray: type === 'Resources' ? [0, 0, 5] : [0, 0, 0] // Apply the dotted line style to the third series in Resources
        },
        fill: {
            type: 'solid', // Remove gradient fill effect
        },
        tooltip: {
            enabled: true,
            theme: 'dark'
        },
        legend: {
            position: 'top',
            horizontalAlign: 'right',
            labels: {
                colors: '#333'
            }
        },
        grid: {
            borderColor: '#e7e7e7',
            xaxis: {
                lines: {
                    show: true
                }
            },
            yaxis: {
                lines: {
                    show: true
                }
            }
        },
        dataLabels: {
            enabled: false, // Remove data labels on all series
        }
    };

    return (
        <div>
            <Chart options={options} series={series} type="line" height={450} />
        </div>
    );
};

export default ResourceDemandModelChart;
